module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', [_vm._m(0), _vm._v(" "), (_vm.boxedit) ? _c('div', {
    staticClass: "intro-y box mt-6"
  }, [_vm._m(1), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.updateEditElement.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-12 sm:col-span-4"
  }, [_c('label', [_vm._v("Razon Social*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client_current.social_reason),
      expression: "client_current.social_reason"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.client_current.social_reason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client_current, "social_reason", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-4"
  }, [_c('label', [_vm._v("Nit*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client_current.nit),
      expression: "client_current.nit"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.client_current.nit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client_current, "nit", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-4"
  }, [_c('label', [_vm._v("Pais")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client_current.country_id),
      expression: "client_current.country_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.client_current, "country_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "seleted": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Seleccione el país")]), _vm._v(" "), _vm._l((_vm.countries), function(country) {
    return _c('option', {
      key: ("country-" + (country.id)),
      domProps: {
        "value": country.id
      }
    }, [_vm._v("\n                " + _vm._s(country.name) + "\n              ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Direccion")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client_current.address),
      expression: "client_current.address"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.client_current.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client_current, "address", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Telefono fijo")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client_current.telphone),
      expression: "client_current.telphone"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.client_current.telphone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client_current, "telphone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-4"
  }, [_c('label', [_vm._v("Nombre")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client_current.contact_purchasing),
      expression: "client_current.contact_purchasing"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.client_current.contact_purchasing)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client_current, "contact_purchasing", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-4"
  }, [_c('label', [_vm._v("Celular")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client_current.cellphone_purchasing),
      expression: "client_current.cellphone_purchasing"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.client_current.cellphone_purchasing)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client_current, "cellphone_purchasing", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-4"
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client_current.email_purchasing),
      expression: "client_current.email_purchasing"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "email"
    },
    domProps: {
      "value": (_vm.client_current.email_purchasing)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client_current, "email_purchasing", $event.target.value)
      }
    }
  })]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-4"
  }, [_c('label', [_vm._v("Nombre")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client_current.contact_treasury),
      expression: "client_current.contact_treasury"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.client_current.contact_treasury)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client_current, "contact_treasury", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-4"
  }, [_c('label', [_vm._v("Celular")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client_current.cellphone_treasury),
      expression: "client_current.cellphone_treasury"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.client_current.cellphone_treasury)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client_current, "cellphone_treasury", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-4"
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client_current.email_treasury),
      expression: "client_current.email_treasury"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "email"
    },
    domProps: {
      "value": (_vm.client_current.email_treasury)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client_current, "email_treasury", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Link")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client_current.link),
      expression: "client_current.link"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.client_current.link)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client_current, "link", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.closeEditElement()
      }
    }
  }, [_vm._v("\n            Cancelar\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "button w-20 bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "create"
    }
  }, [_vm._v("\n            Modificar\n          ")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "overflow-auto"
  }, [_c('table', {
    staticClass: "table table-report -mt-2"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', _vm._l((_vm.clients), function(client) {
    return _c('tr', {
      key: ("client-" + (client.id)),
      staticClass: "intro-x"
    }, [_c('td', {
      staticClass: "w-40 text-center"
    }, [_c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v("\n                " + _vm._s(_vm._f("limit")(client.social_reason)) + "\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "w-40 text-center"
    }, [_c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v("\n                " + _vm._s(client.nit) + "\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "w-40 text-center"
    }, [_c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v("\n                " + _vm._s(client.country.name) + "\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "w-40 text-center"
    }, [(client.link) ? _c('a', {
      staticClass: "font-medium whitespace-no-wrap",
      attrs: {
        "href": client.link,
        "target": "_blank"
      }
    }, [_vm._v("link")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "table-report__action w-56"
    }, [_c('div', {
      staticClass: "flex justify-center items-center"
    }, [_c('router-link', {
      staticClass: "pl-2 w-8 h-8 rounded-full flex items-center justify-center border ml-2 text-gray-500 zoom-in",
      attrs: {
        "to": ("/admin/business/clients/relations/" + (client.id))
      }
    }, [_vm._v("\n                  " + _vm._s(client.accounts.length) + "\n                  "), _c('app-icon', {
      attrs: {
        "name": "folder",
        "classname": "w-4 h-4 mr-2"
      }
    })], 1), _vm._v(" "), _c('button', {
      staticClass: "flex items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md",
      on: {
        "click": function($event) {
          return _vm.editElement(client)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "edit",
        "classname": "w-4 h-4 mr-2"
      }
    })], 1)], 1)])])
  }), 0)])])]) : _c('app-loading'), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": "create-modal"
    }
  }, [_c('div', {
    staticClass: "modal__content modal__content--xl"
  }, [_vm._m(5), _vm._v(" "), _c('form', {
    staticClass: "form-task",
    attrs: {
      "enctype": "multipart/form-data"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createElement.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-12 sm:col-span-4"
  }, [_c('label', [_vm._v("Razon Social*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.social_reason),
      expression: "client.social_reason"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.client.social_reason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client, "social_reason", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-4"
  }, [_c('label', [_vm._v("Nit*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.nit),
      expression: "client.nit"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.client.nit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client, "nit", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-4"
  }, [_c('label', [_vm._v("Pais")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.country_id),
      expression: "client.country_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.client, "country_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "seleted": "",
      "value": "null"
    }
  }, [_vm._v("Seleccione el país")]), _vm._v(" "), _vm._l((_vm.countries), function(country) {
    return _c('option', {
      key: ("country-" + (country.id)),
      domProps: {
        "value": country.id
      }
    }, [_vm._v("\n                " + _vm._s(country.name) + "\n              ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Direccion")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.address),
      expression: "client.address"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.client.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client, "address", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Telefono fijo")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.telphone),
      expression: "client.telphone"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.client.telphone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client, "telphone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-4"
  }, [_c('label', [_vm._v("Nombre")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.contact_purchasing),
      expression: "client.contact_purchasing"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.client.contact_purchasing)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client, "contact_purchasing", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-4"
  }, [_c('label', [_vm._v("Celular")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.cellphone_purchasing),
      expression: "client.cellphone_purchasing"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.client.cellphone_purchasing)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client, "cellphone_purchasing", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-4"
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.email_purchasing),
      expression: "client.email_purchasing"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "email"
    },
    domProps: {
      "value": (_vm.client.email_purchasing)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client, "email_purchasing", $event.target.value)
      }
    }
  })]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-4"
  }, [_c('label', [_vm._v("Nombre")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.contact_treasury),
      expression: "client.contact_treasury"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.client.contact_treasury)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client, "contact_treasury", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-4"
  }, [_c('label', [_vm._v("Celular")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.cellphone_treasury),
      expression: "client.cellphone_treasury"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.client.cellphone_treasury)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client, "cellphone_treasury", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-4"
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.email_treasury),
      expression: "client.email_treasury"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "email"
    },
    domProps: {
      "value": (_vm.client.email_treasury)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client, "email_treasury", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Link")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.link),
      expression: "client.link"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.client.link)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client, "link", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._m(8)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intro-y flex flex-col-reverse sm:flex-row items-center"
  }, [_c('div', {
    staticClass: "w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"
  }), _vm._v(" "), _c('div', {
    staticClass: "w-full sm:w-auto flex"
  }, [_c('a', {
    staticClass: "button text-white bg-theme-1 shadow-md mr-2",
    attrs: {
      "data-target": "#create-modal",
      "data-toggle": "modal"
    }
  }, [_vm._v("Crear Cliente")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("Editar Cliente")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h3', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("Contacto Compras")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h3', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("\n                Contacto Tesoreria\n              ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("RAZON SOCIAL")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("NIT")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("PAIS")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("URL")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("ACCIONES")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("Crear Cliente")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h3', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("Contacto Compras")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h3', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("\n                Contacto Tesoreria\n              ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            Cancelar\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "button w-20 bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "create"
    }
  }, [_vm._v("\n            Crear\n          ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e7284d18","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/clients/ListClients.vue
// module id = 484
// module chunks = 1